import { render } from "./servicios.vue?vue&type=template&id=0708ed07"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"
script.render = render

export default script